<template>
    <div>
        <el-form :inline="true" :model="searchForm">
            <el-form-item label="手机号：">
                <el-input v-model.trim="searchForm.mobile"  @keyup.enter.native="getUserHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="账号：">
                <el-input v-model.trim="searchForm.searchText" placeholder="请输入账号/昵称"  @keyup.enter.native="getUserHandle" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getUserHandle">搜索</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="showAddUser">新增</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border  >
            <el-table-column type="index" label="序号"></el-table-column>      
            <el-table-column prop="id" label="ID" v-if="false"></el-table-column>      
            <el-table-column prop="nickName" label="昵称"></el-table-column>
            <el-table-column prop="accountName" label="账号"></el-table-column>
            <el-table-column prop="mobile" label="手机号"></el-table-column>
            <el-table-column prop="createTime" label="创建时间"></el-table-column>
            <el-table-column prop="stateName" label="状态" sortable></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" @click="showEditUser(scope.row.id)">编辑</el-button>
                    <el-button type="text" @click="resetPwdHandle(scope.row.id)">重置密码</el-button>
                    <el-button type="text" @click="changeStateHandle(scope.row.id)">{{ showbtnText(scope.row.state) }}</el-button>
                    <el-button type="text" @click="showEditUser1(scope.row.id)">删除</el-button>
                    <el-button type="text" @click="getStateChangeRecord(scope.row.id)">操作日志</el-button>
                </template>    
            </el-table-column>>
        </el-table>
        
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 
        <el-dialog :append-to-body="true"  :title="title" :visible.sync="addUserVisible" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="addOrEditUserForm" :model="addOrEditUserForm" :rules="addOrEditUserRoles" label-width="100px">
                <el-form-item label="昵称：" prop="nickName">
                    <el-input v-model.trim="addOrEditUserForm.nickName" clearable></el-input>
                </el-form-item>
                <el-form-item label="账号：" prop="accountName">
                    <el-input v-model.trim="addOrEditUserForm.accountName" clearable></el-input>
                </el-form-item>
                <el-form-item label="手机号：" prop="mobile">
                    <el-input v-model.trim="addOrEditUserForm.mobile" maxlength="11" clearable></el-input>
                </el-form-item>
                <el-form-item  v-if="addUserFlag" label="登录密码：" prop="pwd">
                    <el-input v-model.trim="addOrEditUserForm.pwd" show-password clearable></el-input>
                </el-form-item>
                <el-form-item label="用户角色：" prop="roleIdString">
                    <el-checkbox-group v-model="addOrEditUserForm.roleIdString">
                        <el-checkbox v-for="(role, index) in roleList" :key="index" :label="role.id">{{role.name}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="addOrEditUserHandle">确 定</el-button>
            </div> 
        </el-dialog> 


        <el-dialog :append-to-body="true"  title="操作日志" :visible.sync="actionLogVisible" width="1000px" :close-on-click-modal="false">
            <el-table :data="actionLogTbpg.tableData" border height="421">
                <el-table-column label="序号" type="index" width="50"></el-table-column>
                <el-table-column prop="createTime" label="操作时间" width="140"></el-table-column>
                <el-table-column prop="createOptName" label="操作人" ></el-table-column>
                <el-table-column prop="remark" label="操作原因"></el-table-column>
                <el-table-column prop="stateName" label="操作状态" width="100"></el-table-column>
            </el-table> 
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="actionLogTbpg.currentPage"
                :page-sizes="[10, 50, 100, 500]"
                :page-size="actionLogTbpg.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="actionLogTbpg.total">
            </el-pagination> 
            <span slot="footer" class="dialog-footer">
                <el-button @click="actionLogVisible = false">关 闭</el-button>
            </span>   
        </el-dialog>


    </div>
</template>
<script>
import {addUser, getUserList, resetUserPwd, changeState, getOneUserInfo, editUserInfo, getRoleList, getUserStateChangeRecord,changeState1} from '@/api/user.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                mobile: '',
                searchText: ''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            //操作日志列表
            actionLogVisible: false,
            actionLogTbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },

            addOrEditUserForm: {
                nickName: '',
                accountName: '',
                mobile: '',
                pwd: '',                
                roleIdString: []
            },
            roleList: [],
            title: '新增用户',
            addUserFlag: true,
            userId: null,
            addUserVisible: false,
            addOrEditUserRoles: {
                nickName: [{required: true, message: '请输入昵称', trigger: 'blur'}],
                accountName: [{required: true, validator: this.checkAccount, trigger: 'blur'}],
                mobile: [{required: true, validator: this.checkPhone, trigger: 'blur'}],
                pwd: [{required: true, validator: this.checkPassword, trigger: 'blur'}],
                roleIdString: [{required: true, message: '请选择角色', trigger: 'change'}]
            }
        }
    },
    methods: {
        cancel(){
            this.addUserVisible = false;
            this.$refs.addOrEditUserForm.resetFields();
        },
        showbtnText(state){
            return common.showTxtByState(state, {0: '启用', 1: '禁用'})
        },
        getUserHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            getUserList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        showAddUser(){
            this.title = '新增用户';
            this.addUserVisible = true;
            this.addUserFlag = true;
            getRoleList().then(res => {
                var resultList = res.data.data;
                this.roleList = resultList
            })
        },
        addOrEditUserHandle(){
            this.$refs.addOrEditUserForm.validate(valid => {
                if(valid){
                    var data = JSON.parse(JSON.stringify(this.addOrEditUserForm));
                    data.roleIdString = data.roleIdString.join('|@|');       
                    if(this.addUserFlag){
                        addUser(data).then(res => callback(res))
                    }else{
                        data.id = this.userId;
                        editUserInfo(data).then(res => callback(res))                        
                    }
                }

                var _this = this;
                function callback(res){
                    if(res.data.code == 200){
                        _this.searchForm.mobile = '';
                        _this.getUserHandle();
                        _this.addUserVisible = false;
                        
                    }else{
                        _this.$message.error(res.data.message)
                    }                     
                }
            })            
        },
        showEditUser(id){
            this.title = "修改用户信息";
            this.addUserVisible = true;
            this.addUserFlag = false;
            this.userId = id;
            getOneUserInfo({'id': id}).then(res => {
                var userInfo = res.data.data;
                this.addOrEditUserForm.nickName = userInfo.nickName;
                this.addOrEditUserForm.accountName = userInfo.accountName;
                this.addOrEditUserForm.mobile = userInfo.mobile;                
                this.roleList = userInfo.sysUserRoleVoList;
                userInfo.sysUserRoleVoList.forEach((value, index) => {      
                    if(value['isCheck'] == 1){
                        this.addOrEditUserForm.roleIdString.push(value['id']); 
                    }                    
                });                
            })            
        },  
         showEditUser1(id){
            this.$confirm("您确定要删除代理商嘛？此操作不可逆 请谨慎操作！", "提示" ,{          
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then( () => {
                 changeState1({'id': id}).then(res => {
                    if(res.data.code == 200){
                        this.$message.success('操作成功！')
                        this.getUserHandle();
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            })     
        },           

        getStateChangeRecord(sysUserId, $event){
            common.resetCurrentPage(this, $event, 'actionLogTbpg');
            let data = common.getRequestParams(this, 'actionLogTbpg', {sysUserId: sysUserId});
            getUserStateChangeRecord(data).then(res => {
                common.listCallback(this, res, 'actionLogTbpg');

                this.actionLogVisible = true;

            })            
        },   

        

        changeStateHandle(id){     

            this.$prompt('请输入备注', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValidator: (value) => {
                    if(value==null || value.trim()==""){
                        return '请输入备注';
                    }
                    return true;
                },
            }).then(({ value }) => {
                changeState({'id': id, remark: value}).then(res => {
                    if(res.data.code == 200){
                        this.$message.success('操作成功！')
                        this.getUserHandle();
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            }).catch(() => {
      
            });

        },
        resetPwdHandle(id){
            resetUserPwd({'id': id}).then(res => {
                this.$message.success(res.data.message)
            })
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getUserHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val
            this.getUserHandle();
        }
    },
    created(){
        this.getUserHandle();
    }
}
</script>
<style lang="less" scoped>

</style>

